
import React from 'react';
import { FormLabel, FormDescription } from "@/components/ui/form";
import FileUpload from '@/components/ui/file-upload';
import { Paperclip } from 'lucide-react';

interface QuoteFileUploadFieldProps {
  selectedFile: File | null;
  onFileSelect: (file: File) => void;
  onFileRemove: () => void;
  isLoading: boolean;
}

const QuoteFileUploadField: React.FC<QuoteFileUploadFieldProps> = ({
  selectedFile,
  onFileSelect,
  onFileRemove,
  isLoading
}) => {
  return (
    <div className="space-y-2">
      <FormLabel className="flex items-center gap-2">
        <Paperclip className="w-4 h-4" />
        Quote Document (Optional)
      </FormLabel>
      <FileUpload
        onFileSelect={onFileSelect}
        onFileRemove={onFileRemove}
        selectedFile={selectedFile}
        disabled={isLoading}
      />
      <FormDescription>
        Upload a PDF, DOC, or image file for this quote.
      </FormDescription>
    </div>
  );
};

export default QuoteFileUploadField;
